import React from 'react'
import { connect } from 'react-redux'

import { AppState } from '@chegg-wt/core/state'
import SEOTitle from '@chegg-wt/core/components/SEOTitle'
import { LoadingDots } from '@chegg-wt/core/components/LoadingDots'
import { ProductName } from '@chegg-wt/core/types/site'
import { initializedSelector } from '@chegg-wt/core/state/app/selectors'
import { loggedInSelector } from '@chegg-wt/core/state/user/selectors'
import { BM_PRODUCT_NAME, CTFM_PRODUCT_NAME } from '@chegg-wt/core/constants/site'
import NotLoggedIn from './NotLoggedIn'
import SubscriptionInfo from './SubscriptionInfo'

import { AccountContainer, AccountHeader } from './styled'

/*
  If user NOT logged in
    show links to register + login
  If user logged in
    show link to Chegg subscription page
*/

export interface MyAccountProps {
  initialized: boolean
  notLoggedIn: boolean
  siteName: ProductName
}

export const MyAccount: React.FunctionComponent<MyAccountProps> = ({
  initialized = false,
  notLoggedIn = false,
  siteName,
}) => {
  const tag = [CTFM_PRODUCT_NAME, BM_PRODUCT_NAME].includes(siteName) ? '™' : '®'
  let content: JSX.Element = <SubscriptionInfo siteName={siteName} tag={tag} />
  if (!initialized) {
    content = (
      <LoadingDots data-test="loading" message="Fetching your account information..." />
    )
  } else if (notLoggedIn) {
    content = <NotLoggedIn />
  }

  return (
    <>
      <SEOTitle title={`My Account | ${siteName}`} enable={!!siteName} />
      <AccountContainer>
        <AccountHeader>My account</AccountHeader>
        {content}
      </AccountContainer>
    </>
  )
}

const mapStateToProps = (state: AppState) => ({
  initialized: initializedSelector(state),
  notLoggedIn: !loggedInSelector(state),
})

export default connect(mapStateToProps)(MyAccount)
